import { render, staticRenderFns } from "./AddCooperativePartner.vue?vue&type=template&id=0ed9ffa8&scoped=true"
import script from "./AddCooperativePartner.vue?vue&type=script&lang=js"
export * from "./AddCooperativePartner.vue?vue&type=script&lang=js"
import style0 from "./AddCooperativePartner.vue?vue&type=style&index=0&id=0ed9ffa8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ed9ffa8",
  null
  
)

export default component.exports